<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">订单管理</el-breadcrumb-item>
        <el-breadcrumb-item>拼多多电子面单</el-breadcrumb-item>

        <el-breadcrumb-item> > 打印前请先安装拼多多专属打印组件，打印组件的下载地址
          <a href="https://meta.pinduoduo.com/api/one/app/v1/lateststable?appId=com.xunmeng.pddprint&platform=windows&subType=main"
            target="_blank" style="color: blue; cursor: pointer;">点击下载 拼多多专属打印组件</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </template>

    <el-form class="search-form">
      <el-row>
        <el-form-item label="选择打印机">
          <el-col>
            <el-select v-model="printDefault" placeholder="打印机" style="width: 380px">
              <el-option v-for="item in printDevices" :key="item.name" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="" label-width="20px">
          <el-button plain type="primary" icon="printer" @click="savePddPrintEvent()">保存并打印面单</el-button>
        </el-form-item>
        <el-form-item label="" label-width="20px">
          <el-button plain type="default" icon="TakeawayBox" @click="$router.push('printHistory')">历史面单</el-button>
        </el-form-item>
        <!-- <el-form-item label="" label-width="20px">
          <el-button plain type="default" @click="testSendPrints()">测试打印</el-button>
        </el-form-item> -->
      </el-row>
    </el-form>


    <!-- 电子面单打印 -->
    <el-table :data="printData" stripe border size="small" height="450">
      <el-table-column prop="orderNo" label="平台订单号" width="190" show-overflow-tooltip>
        <template #header>
          <el-checkbox label="全选" @change="checkAllChanges" v-model="checkAll">平台订单号</el-checkbox>
        </template>
        <template #default="scope">
          <el-checkbox-group v-model="checkList" v-if="!scope.row.expressPostNo" size="small">
            <el-checkbox v-for="value in scope.row.orderNo.split(',')" :key="value" :label="value"
              style="display: block; height: 25px; line-height: 25px;" />
          </el-checkbox-group>
        </template>
      </el-table-column>
      <!-- <el-table-column type="index" align="center" label="序号" width="45"> </el-table-column> -->
      <el-table-column prop="dataFrom" label="平台" width="70" show-overflow-tooltip sortable> </el-table-column>
      <!-- <el-table-column prop="orderNo" label="平台订单号" width="150" show-overflow-tooltip>
          <template #default="scope">
            <div v-for="value in scope.row.orderNo.split(',')" :key="value">{{ value }}</div>
          </template>
        </el-table-column> -->

      <el-table-column prop="receiverName" label="收件人" width="80" show-overflow-tooltip sortable> </el-table-column>
      <el-table-column prop="receiverMobile" label="手机号" width="100" show-overflow-tooltip sortable></el-table-column>
      <el-table-column prop="receiverProvince" label="省" width="90" show-overflow-tooltip sortable></el-table-column>
      <el-table-column prop="receiverCity" label="市" width="90" show-overflow-tooltip sortable></el-table-column>
      <el-table-column prop="receiverArea" label="区" width="85" show-overflow-tooltip sortable></el-table-column>
      <!-- <el-table-column prop="receiverTown" label="街道" width="90" show-overflow-tooltip sortable></el-table-column> -->
      <el-table-column prop="receiverAddress" label="地址" width="160" show-overflow-tooltip sortable></el-table-column>
      <el-table-column prop="quantity" label="数量" width="50"> </el-table-column>
      <el-table-column prop="expressCode" width="100" label="快递公司">
        <template #header>
          <el-select v-model="logisticsId" placeholder="设置快递" size="small" style="width: 100%"
            @change="changeAllExpress">
            <el-option v-for="item in dict.logistics" :key="item.code" :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </template>
        <template #default="scope">
          <el-select v-model="scope.row.logisticsId" placeholder="快递" size="small" style="width: 100%">
            <el-option v-for="item in dict.logistics" :key="item.code" :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="expressPostNo" width="80" label="快递单号" show-overflow-tooltip>
        <template #default="scope">
          <span v-if="(scope.row.expressPostNo || '').length > 0">{{ scope.row.expressPostNo }}</span>
          <span v-else>打印后返回</span>
        </template>
      </el-table-column>
      <el-table-column prop="insureFee" width="100" label="投保金额(元)" align="center">
        <template #default="scope">
          <el-input-number v-model="scope.row.insureFee" :precision="0" :step="100" size="small" :min="0" :max="999999"
            :controls="false" style="max-width: 90%; height: 2.2em;"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column prop="senderName" width="90" label="发件人" sortable>
        <template #default="scope">
          <el-select v-model="scope.row.senderName" placeholder="" size="small" style="width: 100%">
            <el-option v-for="item in dict.senders" :key="item.senderName" :label="item.senderName"
              :value="item.senderName"> </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" show-overflow-tooltip sortable>
        <template #default="scope">
          <div v-for="value in scope.row.remark.split('\n')" :key="value">{{ value }}</div>
        </template>
      </el-table-column>
    </el-table>

  </el-card>
</template>
<script>
import StaticDialog from "@/components/static-dialog.vue";
import BasicTable from "@/components/basic-table.vue";
import { pddPrintData, savePddPrintData, getSenders, getPddLogistics } from "@/api/order";
import { resultProps } from "element-plus/lib/components/index.js";
export default {
  name: "pddPrintInfo",
  components: { StaticDialog, BasicTable },
  data() {
    return {
      printDefault: '', // -1默认打印机
      printDevices: [],
      socketer: null,

      printData: [],
      dict: {
        express: [],
        senders: []
      },
      checkAll: false,
      checkList: [],
      allIdList: [],

      status: null,
      logisticsId: null,
    };
  },
  methods: {
    fetchs() {
      let that = this;
      that.allIdList = [];
      pddPrintData(this.status).then((res) => {
        that.printData = [];
        if (res.code === 200) {
          that.printData = res.data;
          that.printData.forEach((res) => {
            res.senderName = that.dict.senders[0].senderName;

            res.orderNo.split(',').forEach((orderNo) => {
              if (orderNo || orderNo.length > 0)
                that.allIdList.push(orderNo);
            });

            if (that.logisticsId) {
              var logistics = that.dict.logistics.filter(q => q.code == that.logisticsId)[0];
              //res.expressId = express.id;
              res.expressCode = logistics.code;
            }
          });
        }
      },
        (err) => {
          this.$alert(err.content, '提示')
        }
      )
    },
    savePddPrintEvent() {
      if (this.printData.filter(row => !row.logisticsId).length > 0) {
        this.$alert('请选择设置对应订单的快递方式', '提示');
        return;
      }

      let checkedPrintData = [];
      this.printData.forEach((row) => {
        //勾选的打印单
        if (row.orderNo.split(',').filter(q => q.length > 0 && this.checkList.indexOf(q) > -1).length > 0) {
          row.senderName = this.dict.senders.filter(q => q.senderName == row.senderName)[0].senderName;
          row.senderMobile = this.dict.senders.filter(q => q.senderName == row.senderName)[0].senderMobile;
          row.senderProvince = this.dict.senders.filter(q => q.senderName == row.senderName)[0].senderProvince;
          row.senderCity = this.dict.senders.filter(q => q.senderName == row.senderName)[0].senderCity;
          row.senderArea = this.dict.senders.filter(q => q.senderName == row.senderName)[0].senderArea;
          row.senderAddress = this.dict.senders.filter(q => q.senderName == row.senderName)[0].senderAddress;

          var logistics = this.dict.logistics.filter(q => q.code == row.logisticsId)[0];
          row.logisticsId = logistics.code;
          row.expressCode = logistics.code;
          // row.expressName = logistics;
          // row.expressBizName = logistics;
          // row.expressBizCode = logistics;

          checkedPrintData.push(row);
        }
      });
      if (checkedPrintData.length == 0) {
        this.$alert('请勾选要保存打印的单据信息', '提示');
        return;
      }

      //console.log('checkedPrintData', checkedPrintData);
      // if (!this.printDefault || !this.socketer) {
      //   this.$message({ message: '拼多多打印组件加载错误，请安装打印组件后再尝试' });
      //   return;
      // }

      this.$confirm('确认保存并打印勾选的快递单据, 是否继续?', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          savePddPrintData(checkedPrintData).then(
            (res) => {
              if (res && res.code == 200) {
                this.sendPrinters(res.data);
              }
              this.$alert(res.content, '系统提示', {
                confirmButtonText: '确认',
                callback: (action) => {
                  this.fetchs();
                },
              })
            },
            (err) => {
              this.$alert(err.content, '错误提示', {
                confirmButtonText: '确认',
                callback: (action) => {
                  this.fetchs();
                },
              })
            }
          );
        })
    },
    checkAllChanges() {
      if (this.checkAll)
        this.checkList = this.allIdList;
      else
        this.checkList = [];
    },
    changeAllExpress() {
      this.printData.forEach((res) => {
        //res.expressCode = this.expressCode;
        var logistics = this.dict.logistics.filter(q => q.code == this.logisticsId)[0];
        res.logisticsId = logistics.code;
        res.expressCode = logistics.code;
      });
    },

    initPrinters() {
      let that = this;

      this.socketer = new WebSocket('ws://127.0.0.1:5000');
      this.socketer.onopen = function (event) {
        that.getPrinters(); //获取打印列表
      };
      // 监听消息
      that.socketer.onmessage = function (event) {
        // 获取拼多多返回的信息
        console.log('pdd client message', JSON.stringify(event.data));
        console.log('打印机列表1', JSON.parse(event.data).printers)

        if (JSON.parse(event.data).printers !== undefined) {
          that.printDevices = JSON.parse(event.data).printers
          console.log('打印机列表2', that.printDevices)
        }
        if (JSON.parse(event.data).defaultPrinter) {
          that.printDefault = JSON.parse(event.data).defaultPrinter;

          // JSON.parse 用来解析JSON字符串
          console.log("默认打印机：" + JSON.parse(event.data).defaultPrinter)
          // defaultPrinter = 'OneNote for Windows 10'
        }

        if (JSON.parse(event.data).status === 'success') {
          console.log("打印就绪..")
          that.$message("打印就绪..");
        }
        if (JSON.parse(event.data).taskStatus === 'printed') {
          console.log('出纸成功')
          that.$message("出纸成功..");
          that.$kaung.pushlogs({ controler: "successPrinter", body: '', result: JSON.stringify(event.data) })
        }
        if (JSON.parse(event.data).taskStatus === 'failed') {
          // document.querySelector('.msg').innerText = JSON.stringify(event.data)
          console.log("打印失败!", JSON.stringify(event.data))
          that.$kaung.pushlogs({ controler: "errorPrinter", body: '', result: JSON.stringify(event.data) })
          that.$message("打印失败");
        }
        if (JSON.parse(event.data).taskStatus === 'canceled') {
          console.log("打印取消!")
          that.$message("打印取消");
        }
      };

      // 监听Socket的关闭
      this.socketer.onclose = function (event) {
        console.log('Client notified socket has closed', event);
        that.printDefault = '';
        that.printDevices = [];
        that.$alert('请检查是否安装拼多多打印组件或是否开启了打印组件', '拼多多打印组件加载失败');
      };
    },
    getPrinters() {
      var request = this.getRequestObject("getPrinters");
      if (this.socketer.readyState === 1) {
        this.socketer.send(JSON.stringify(request));
      }
    },
    testSendPrints() {
      // let request = {
      //   "ERPId": "isv id",
      //   "ISVName": "isv name",
      //   "cmd": "print",
      //   "requestID": this.$util.getUUID(8, 16),
      //   "task": {
      //     "documents": [
      //       {
      //         "contents": [
      //           {
      //             "addData": {
      //               "sender": {
      //                 "address": {
      //                   "city": "上海市",
      //                   "detail": "陕西面馆",
      //                   "district": "长宁区",
      //                   "province": "上海市"
      //                 },
      //                 "mobile": "333333333333",
      //                 "name": "ceshi"
      //               }
      //             },
      //             "encryptedData": "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?v=10&pv=1",
      //             "signature": "PAPe5OYetWzKlZD3Wnvi4BPKI6CeCybLmYgzZioIw0XAs7dOdosozY9XXoYDf4cnByiza/JuDvoYQvgh+HYqaCNnJ0G1WnScQ7MSoWGkIcE6FBOxFhsbokLNX2ixiOQ4ERCuozajDsSYpDyOpqvDB4vT5AALyQjXAfnR8GyR/B4=",
      //             "templateUrl": "https://file-link.pinduoduo.com/zto_one",
      //             "userid": "480261061",
      //             "ver": "10"
      //           },
      //           {
      //             "data": {
      //               "height": 240,
      //               "list": [
      //                 {
      //                   "fontSize": 31.2,
      //                   "height": 45.68,
      //                   "left": 2.08,
      //                   "text": "[备注: 没有什么备注]",
      //                   "top": 2.08,
      //                   "width": 413.52
      //                 }
      //               ],
      //               "waterdata": {
      //                 "text": ""
      //               },
      //               "width": 560
      //             },
      //             "templateURL": "http://pinduoduoimg.yangkeduo.com/logistics/2019-07-14/5d7e8b5969d954539fcfba3268bbeb3a.xml"
      //           }
      //         ],
      //         "documentID": "5520010649869215"
      //       }
      //     ],
      //     "notifyType": [
      //       "print"
      //     ],
      //     "preview": false,
      //     "previewType": "image",
      //     "printer": this.printDefault,
      //     "taskID": this.$util.getUUID(8, 10)
      //   },
      //   "version": "1.0"
      // };
      // console.log('testSendPrints', JSON.stringify(request));
      // this.socketer.send(JSON.stringify(request));

      let that = this;
      this.$prompt("<strong>请输入要打印的JSON信息</strong>",
        "打印测试提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputErrorMessage: '',
          inputPlaceholder: '请输入要打印的完整JSON信息',
          inputValue: '',
          type: "warning",
          dangerouslyUseHTMLString: true,
        })
        .then(({ value }) => {
          console.log('testSendPrints', value);
          if (value.length > 30)
            this.socketer.send(value);
        });
    },
    sendPrinters(docs) {
      console.log('sendPrinters', docs);
      var request = this.getRequestObject("print");
      request.ERPId = "printERPId";
      request.ISVName = "printERPName";

      request.task = new Object();
      request.task.taskID = this.$util.getUUID(8, 10);
      request.task.preview = false;
      request.task.previewType = "image";
      request.task.printer = this.printDefault;
      request.task.notifyType = ["print"];
      request.task.documents = docs;

      // // 把每次打印的任务 taskID 保存到 taskIDArray 数组
      // taskIDArray.push(request.task.taskID);

      // // 记录当前打印请求的ID
      // requestIDGetGlobalConfig = request.task.taskID


      console.log('发送打印数据', JSON.stringify(request));
      this.$kaung.pushlogs({ controler: "sendPrinter", body: JSON.stringify(request), result: '' })
      this.socketer.send(JSON.stringify(request));
    },
    // 构造request对象 
    getRequestObject(cmd) {
      var request = new Object();
      // 必须:请求的ID,用于唯一标识每个请求，每个客户端保证生成唯一的ID
      request.requestID = this.$util.getUUID(8, 16);
      //必须: 协议当前版本
      request.version = "1.0";
      //必须: 请求命令名称
      request.cmd = cmd;
      return request;
    }
  },
  watch: {
  },
  created: function () {
    this.dev = process.env;
    this.status = this.$route.query.status || '10';

    this.initPrinters();

    //this.$kaung.dictionary("stock", "express").then(res => this.dict.express = res);
    getPddLogistics().then(res => this.dict.logistics = res);
    getSenders().then(res => this.dict.senders = res);

    this.fetchs();
  },
  computed: {
  },
};
</script>
